import type { Style } from "../types";
import { StyleCreate, StyleEdit } from "./StyleEdit";
import { StyleList } from "./StyleList";
import { StyleShow } from "./StyleShow";

export default {
  list: StyleList,
  show: StyleShow,
  create: StyleCreate,
  edit: StyleEdit,
  recordRepresentation: (record: Style) => record.name,
};
